<template>
  <div :class="['dependentdropdown', { 'dependentdropdown--rtl': isRTL }]">
    <RelatedDropdownPanel
      v-if="sddOptions && sddOptions.length"
      :display-horiz="displayHoriz"
      :has-heading="hasHeading"
      :heading-title="dfltHeadingText"
      :has-cta="hasCta"
      :button-text="dfltCtaText"
      @submit-related-dropdown="getSelectedData"
    >
      <Dropdown
        :id="firstSddId"
        :name="firstSddName"
        :label="dfltFirstLabel"
        :message="firstSddLabelMessage"
        :placeholder="firstSddPlaceholder"
        :value="firstSelectedValue"
        :options="sddOptions"
        :group-option="groupOption"
        :group-option-label="groupOptionLabel"
        :group-option-value="groupOptionValue"
        :key-value="keyValue"
        :key-label="keyLabel"
        @related-dropdown-change="changeFirstSdd"
      />
      <Dropdown
        v-if="showSecondSecondSelect"
        :id="secondSddId"
        :class="{ 'dependentdropdown--disabled': disabledSecondSelect }"
        :disabled="disabledSecondSelect"
        :name="secondSddName"
        :label="dfltSecondLabel"
        :message="secondSddLabelMessage"
        :placeholder="secondSddPlaceholder"
        :value="secondSelectedValue"
        :options="secondSddOptions"
        :group-option="groupOption"
        :group-option-label="groupOptionLabel"
        :group-option-value="groupOptionValue"
        :key-value="keyValue"
        :key-label="keyLabel"
        @related-dropdown-change="changeSecondSdd"
      />
    </RelatedDropdownPanel>
  </div>
</template>
<script>
  import RelatedDropdownPanel from './RelatedDropdownPanel.vue';
  import Dropdown from './Dropdown.vue';
  import messages from './../assets/generated/i18n/i18n.json';
  export default {
    name: 'RelatedDropdown',
    components: {
      RelatedDropdownPanel,
      Dropdown,
    },
    i18n: { messages },
    props: {
      /**
       * Set to "currencySelector" to display related select with curency selector translations.
       * by default value is geolocSelector.
       * To add a new key of translation you have to add translations on google sheet with this key.
       */
      tradContextPre: {
        type: String,
        default: 'geolocSelector',
      },
      lang: {
        type: String,
        default: 'en',
      },
      /**
       * Set to "false" to hide the component heading.
       * by default value is true.
       */
      hasHeading: {
        type: Boolean,
        default: true,
      },
      /**
       * the default value is retrieved from the i18n
       * you can customize the title
       */
      headingTitle: {
        type: String,
        default: null,
      },
      /**
       * If this props is not set, or if an empty array the component is not displayed
       * if this props is passed with the correct shema, the component is displayed
       * please refer to sddOptions Object Schema below
       */
      sddOptions: {
        type: Array,
        required: true,
      },
      /**
       * the first dropdown default value is retrieved from the i18n
       * you can customize the first label for the first dropdown
       */
      firstSddLabel: {
        type: String,
        default: null,
      },
      /**
       * you can customize the first label helper for the first dropdown
       */
      firstSddLabelMessage: {
        type: String,
        default: null,
      },
      /**
       * the defut id is firstSelectDropDown
       * you can customize the first dropdown id
       */
      firstSddId: {
        type: String,
        default: 'firstSelectDropDown',
      },
      /**
       * the defut id is firstSelectDropDown
       * you can customize the first dropdown name
       */
      firstSddName: {
        type: String,
        default: 'firstSelectDropDown',
      },
      /**
       * By default we have no placehoder
       * you can add a placeholder to the first dropdown
       */
      firstSddPlaceholder: {
        type: String,
        default: null,
      },
      /**
       * By default the first selected value in the dropdown is the first option
       * you can set à value you want to select by defaut on the first select
       */
      firstSddSelected: {
        type: [String, Number],
        default: -1,
      },
      /**
       * the defut id is SecondSelectDropDown
       * you can customize the second dropdown id
       */
      secondSddId: {
        type: String,
        default: 'SecondSelectDropDown',
      },
      /**
       * the defut id is SecondSelectDropDown
       * you can customize the second dropdown name
       */
      secondSddName: {
        type: String,
        default: 'SecondSelectDropDown',
      },
      /**
       * the second dropdown default value is retrieved from the i18n
       * you can customize the  label for the second dropdown
       */
      secondSddLabel: {
        type: String,
        default: null,
      },
      /**
       * you can customize the first label helper for the second dropdown
       */
      secondSddLabelMessage: {
        type: String,
        default: null,
      },
      /**
       * By default we have no placehoder
       * you can add a placeholder to the second dropdown
       */
      secondSddPlaceholder: {
        type: String,
        default: null,
      },
      /**
       * By default the first selected value in the dropdown is the first option
       * you can set à value you want to select by defaut on the second select
       */
      secondSddSelected: {
        type: [String, Number],
        default: -1,
      },
      /**
       * By default the disabled mode is false so the second select is not displayed until you have selected a value in the first one
       * Set to "true" to display the second select with the disabled mode.
       */
      disabledMode: {
        type: Boolean,
        default: false,
      },
      /**
       * by default the component is displayed vertically
       * Set to "true" to display the component horizontally
       */
      displayHoriz: {
        type: Boolean,
        default: false,
      },
      /**
       * by default the we had à call to action to submit selected values
       * Set to "false" to hide cta
       */
      hasCta: {
        type: Boolean,
        default: true,
      },
      /**
       * by default the button text is retrieved from the i18n
       * you can customize the  text button
       */
      buttonText: {
        type: String,
        default: null,
      },
      groupOption: {
        type: Boolean,
        default: false,
      },
      groupOptionLabel: {
        type: String,
        default: null,
      },
      groupOptionValue: {
        type: String,
        default: null,
      },
      keyValue: {
        type: String,
        default: 'value'
      },
      keyLabel: {
        type: String,
        default: 'text'
      },
    },
    data() {
      return {
        secondSddOptions: [],
        disabledSecondSelect: false,
        firstSelectedValue: '',
        secondSelectedValue: '',
      };
    },
    computed: {
      dfltFirstLabel() {
        return (
          this.firstSddLabel || messages[this.lang][this.tradContextPre].geographicalArea.label || 
          this.$t(this.tradContextPre + '.geographicalArea.label')
        );
      },
      dfltSecondLabel() {
        return (
          this.secondSddLabel || messages[this.lang][this.tradContextPre].country.label || this.$t(this.tradContextPre + '.country.label')
        );
      },
      dfltCtaText() {
        return (
          this.buttonText || messages[this.lang][this.tradContextPre].ctaValidate.text || this.$t(this.tradContextPre + '.ctaValidate.text')
        );
      },
      dfltHeadingText() {
        return (
          this.headingTitle || messages[this.lang][this.tradContextPre].heading.text || this.$t(this.tradContextPre + '.heading.text')
        );
      },
      isRTL() {
        if (this.$i18n && this.$i18n.locale === 'ar') {
          return true;
        } else if (document.querySelector('html').dir === 'rtl') {
          return true;
        }
        return false;
      },
      showSecondSecondSelect() {
        if (
          this.disabledSecondSelect &&
          !this.secondSddOptions.length &&
          this.checkoutOptions()
        ) {
          return true;
        }
        if (!this.disabledSecondSelect && this.secondSddOptions.length) {
          return true;
        }
        return false;
      },
    },
    mounted() {
      this.firstSelectedValue = this.firstSddSelected;
      this.secondSelectedValue = this.setSecondSddValue();
      this.secondSddOptions =
        this.dependentDataOptions(this.firstSelectedValue) || [];
      this.disabledSecondSelect = this.setDisabledBySecondSelect();
    },
    methods: {
      setDisabledBySecondSelect() {
        if (this.disabledMode && this.secondSddOptions.length) {
          return false;
        }
        if (this.disabledMode && !this.secondSddOptions.length) {
          return true;
        }
        return false;
      },
      checkoutOptions() {
        return (
          this.sddOptions &&
          this.sddOptions
            .map(
              (item) =>
                item.options !== undefined &&
                Array.isArray(item.options) &&
                item.options.length > 0
            )
            .includes(true)
        );
      },
      setSecondSddValue() {
        if (
          !this.dependentDataOptions(this.firstSelectedValue) ||
          !this.dependentDataOptions(this.firstSelectedValue).filter(
            (item) => item.value === this.secondSddSelected
          ).length
        ) {
          return '';
        }
        return this.secondSddSelected;
      },
      changeFirstSdd(value) {
        this.firstSelectedValue = value;
        if (this.checkDataOptions(value)) {
          this.secondSddOptions = this.dependentDataOptions(value);
          this.secondSelectedValue = this.secondSddPlaceholder
            ? -1
            : this.dependentDataOptions(value)[0].value;
          this.disabledSecondSelect = false;
        } else {
          this.secondSddOptions = [];
          this.secondSelectedValue = '';
          this.disabledSecondSelect = this.disabledMode ? true : false;
        }
        this.$emit('first-sdd-change', value);
      },
      changeSecondSdd(value) {
        this.secondSelectedValue = value;
        this.$emit('second-sdd-change', value);
      },
      checkDataOptions(value) {
        const dataBySelectedValue =
          this.sddOptions && this.sddOptions.length
            ? this.sddOptions.filter(($item) => $item.value === value)
            : null;
        return (
          dataBySelectedValue &&
          dataBySelectedValue.length &&
          dataBySelectedValue[0].options &&
          dataBySelectedValue[0].options.length
        );
      },
      dependentDataOptions(value) {
        if (this.checkDataOptions(value)) {
          return this.sddOptions.filter(($item) => $item.value === value)[0]
            .options;
        } else {
          return null;
        }
      },
      getSelectedData() {
        const sddSelectedValues = [];
        this.firstSelectedValue &&
          this.firstSelectedValue != -1 &&
          sddSelectedValues.push(this.firstSelectedValue);
        this.secondSelectedValue &&
          this.secondSelectedValue != -1 &&
          this.secondSddOptions.length &&
          sddSelectedValues.push(
            ...this.secondSddOptions.filter(
              (option) => option.value === this.secondSelectedValue
            )
          );
        this.$emit('get-relateddropdown-data', sddSelectedValues);
      },
    },
  };
</script>

<style lang="scss">
.dependentdropdown {
  align-items: center;
  display: flex;
  flex-direction: column;
  font-family: $font-roboto;
  padding: $gutter;

  * {
    box-sizing: content-box;
  }

  &__form {
    display: flex;
    flex-direction: column;
    min-width: 300px;
    padding: $xl-gutter 0 0;
  }

  &--rtl {
    direction: rtl;
    .dependentdropdown {
      &__field {
        &-icon {
          right: calc(100% - 30px);
        }
      }
    }
  }

  &__form {
    &--row {
      flex-direction: row;
      .dependentdropdown__field {
        padding: 0 0 0 20px;
        justify-content: flex-end;
      }
    }
  }
}
</style>
